import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {rbacActions} from '../../config/rbac/actions.ts';

// FNP-995. One route only — the registry is read-only by construction, so
// there is no add or edit page to guard.
export const TestingRegistryLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <RequirePermission action={rbacActions.ListRegisteredActions}>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
